import { Toaster } from 'react-hot-toast';
import { BrowserRouter } from 'react-router-dom';
import { HashProvider } from '../../Hooks/UseHash';
import useMobileVh from '../../Hooks/UseMobileVh';
import InsuranceLicenseContent from './InsuranceLicenseContent';

type Props = {
	hash: string;
};

export default function InsuranceLicense(props: Props) {
	const { hash } = props;
	useMobileVh();

	return (
		<HashProvider hash={hash}>
			<BrowserRouter basename={`/u/insurance-license/${hash}`}>
				<div className="container insurance-license-page">
					<div className="row">
						<div className="col-xs-12">
							<InsuranceLicenseContent />
						</div>
					</div>
				</div>
				<Toaster position="bottom-right" />
			</BrowserRouter>
		</HashProvider>
	);
}
